<template>
  <div class="base">
    <!--impersona></impersona-->
    <navbar></navbar>

    <b-container class="main_box">
      <b-row>
        <b-col style="padding: 0">
          <router-view/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import navbar from '@/components/navbar.vue'

export default {
  name: 'basebox',
  data() {
    return {
    }
  },
  components: {
    navbar
  }
}
</script>

<style>
body{
  background: #e9ebee !important;
}

.main_box{
  margin-top: 10px;
  background: white;
  border-radius: 2px;

  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

/*HEADER*/
.headerbox{
  background-image: linear-gradient(to right, #493240, #493240);
  color: white;
  border-radius: 2px 2px 0 0;
  padding: 5px;
}

.headerbox h5{
  margin: 0;
}

/*SEPARATORE*/
.separatore_text{
  color: gray;
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
}

/*INPUT*/
.slide-up {
  display: inline-block;
  /*width: 215px;*/
  padding: 10px 0 10px 15px;
  /*font-family: "Open Sans", sans;*/
  font-weight: 400;
  /*color: #377D6A;*/
  background: #efefef !important;
  border: 0;
  border-radius: 3px;
  outline: 0;
  /*text-indent: 150px;*/
  transition: all .3s ease-in-out;
}
.slide-up::-webkit-input-placeholder {
  color: #efefef !important;
  text-indent: 0;
  font-weight: 300;
}
.slide-up + label {
  display: inline-block;
  position: absolute;
  transform: translateX(0);
  top: 0;
  left: 15px;
  padding: 7px 15px;
  text-shadow: 0 1px 0 rgba(19, 74, 70, 0.4);
  transition: all .3s ease-in-out;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  overflow: hidden;
  color: white;
}
.slide-up + label:before, .slide-up + label:after {
  content: "";
  position: absolute;
  right: 0;
  left: 0;
  z-index: -1;
  transition: all .3s ease-in-out;
}
.slide-up + label:before {
  top: 6px;
  left: 5px;
  right: 5px;
  bottom: 6px;
  /*background: #377D6A;*/
  background-image: linear-gradient(to right, #493240, #493240);
}
.slide-up + label:after {
  top: 0;
  bottom: 0;
  /*background: #377D6A;*/
  background-image: linear-gradient(to right, #493240, #493240);
}

span:nth-child(1) .slide-up {
  text-indent: 105px;
}

span:nth-child(3) .slide-up {
  text-indent: 125px;
}

span:nth-child(1) .slide-up:focus,
span:nth-child(1) .slide-up:active,
span:nth-child(3) .slide-up:focus,
span:nth-child(3) .slide-up:active {
  text-indent: 0 !important;
}

.slide-up:focus:not([disabled]),
.slide-up:active:not([disabled]) {
  /*color: #377D6A;*/
  text-indent: 0 !important;
  background: #fff !important;
}
.slide-up:focus:not([disabled])::-webkit-input-placeholder,
.slide-up:active:not([disabled])::-webkit-input-placeholder {
  color: #aaa !important;
}
.slide-up:focus:not([disabled]) + label,
.slide-up:active:not([disabled]) + label {
  transform: translateY(-100%);
}
.slide-up:focus + label:before,
.slide-up:active + label:before {
  border-radius: 5px;
}
.slide-up:focus:not([disabled]) + label:after,
.slide-up:active:not([disabled]) + label:after {
  transform: translateY(100%);
}
.slide-up:disabled + label:after,
.slide-up:disabled + label:before {
  background: #797979;
}

.fix_datetime_picker + label {
  left: 0 !important; 
  height: 100% !important;
}

@media screen and (max-width: 1040px) {
  .main_box {
    margin-top: 40px;
  }
}

/* CARICAMENTO */
.sk-cube-grid {
  float: right;
  width: 20px;
  height: 20px;
  margin-left: 10px;
}

.sk-cube-grid .sk-cube {
  width: 33%;
  height: 33%;
  background-color: white;
  float: left;
  -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
          animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out; 
}
.sk-cube-grid .sk-cube1 {
  -webkit-animation-delay: 0.2s;
          animation-delay: 0.2s; }
.sk-cube-grid .sk-cube2 {
  -webkit-animation-delay: 0.3s;
          animation-delay: 0.3s; }
.sk-cube-grid .sk-cube3 {
  -webkit-animation-delay: 0.4s;
          animation-delay: 0.4s; }
.sk-cube-grid .sk-cube4 {
  -webkit-animation-delay: 0.1s;
          animation-delay: 0.1s; }
.sk-cube-grid .sk-cube5 {
  -webkit-animation-delay: 0.2s;
          animation-delay: 0.2s; }
.sk-cube-grid .sk-cube6 {
  -webkit-animation-delay: 0.3s;
          animation-delay: 0.3s; }
.sk-cube-grid .sk-cube7 {
  -webkit-animation-delay: 0s;
          animation-delay: 0s; }
.sk-cube-grid .sk-cube8 {
  -webkit-animation-delay: 0.1s;
          animation-delay: 0.1s; }
.sk-cube-grid .sk-cube9 {
  -webkit-animation-delay: 0.2s;
          animation-delay: 0.2s; }

.hide_class{
  /*display: none !important;*/
  visibility: hidden;
  height: 0;
}

@-webkit-keyframes sk-cubeGridScaleDelay {
  0%, 70%, 100% {
    -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
  } 35% {
    -webkit-transform: scale3D(0, 0, 1);
            transform: scale3D(0, 0, 1); 
  }
}

@keyframes sk-cubeGridScaleDelay {
  0%, 70%, 100% {
    -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
  } 35% {
    -webkit-transform: scale3D(0, 0, 1);
            transform: scale3D(0, 0, 1);
  } 
}
</style>
